import { URLS } from 'constants/urls'
import { useDisableMenuItems } from 'hooks/useDisableMenuItems'
import { useMemo } from 'react'
import { useAppSelector } from 'redux/hooks'
import { userDataSelector } from 'redux/login/selectors'
import { MENU_NAMES } from 'texts/menuNames'

export const useNavigationItems = () => {
  const { disableMenuItem } = useDisableMenuItems()
  const { accountStatus, sectionsStatuses } = useAppSelector(userDataSelector)

  const items: {
    label: string
    getPath: (id: string) => string
    activePath?: string
    isDisabled?: boolean
  }[] = useMemo(
    () => [
      {
        label: MENU_NAMES.DASHBOARD,
        getPath: (id: string) => `${URLS.DASHBOARD}/${id}`,
        activePath: URLS.DASHBOARD,
      },
      {
        label: MENU_NAMES.PROFILE_DETAILS.NAME,
        getPath: (id: string) =>
          `${URLS.PROFILE}${URLS.PROFILE_LIST}/${id}/edit`,
      },
      {
        label: MENU_NAMES.DOCUMENTS,
        getPath: (id: string) => `${URLS.DOCUMENTS}/${id}`,
      },
      {
        label: MENU_NAMES.BOOKING_HISTORY,
        getPath: (id: string) => `${URLS.BOOKING_HISTORY}/${id}`,
        isDisabled: disableMenuItem(MENU_NAMES.BOOKING_HISTORY),
      },
      {
        label: MENU_NAMES.LOCATIONS,
        getPath: (id: string) =>
          `${URLS.LOCATIONS}${URLS.LIST_OF_LOCATIONS}/${id}`,
        isDisabled: disableMenuItem(MENU_NAMES.LOCATIONS),
      },
      {
        label: MENU_NAMES.VEHICLES,
        getPath: (id: string) => `${URLS.FLEET}${URLS.VEHICLES}/${id}`,
        isDisabled: disableMenuItem(MENU_NAMES.VEHICLES),
      },
      {
        label: MENU_NAMES.EQUIPMENTS,
        getPath: (id: string) => `${URLS.FLEET}${URLS.EQUIPMENTS}/${id}`,
        isDisabled: disableMenuItem(MENU_NAMES.EQUIPMENTS),
      },
      {
        label: MENU_NAMES.PRICE_LISTS,
        getPath: (id: string) => `${URLS.FLEET}${URLS.PRICE_LIST}/${id}`,
        isDisabled: disableMenuItem(MENU_NAMES.PRICE_LISTS),
      },
      {
        label: MENU_NAMES.DROP_OFF_FEE,
        getPath: (id: string) => `${URLS.DROP_OFF_FEE}/${id}`,
        isDisabled: disableMenuItem(MENU_NAMES.DROP_OFF_FEE),
      },
      {
        label: MENU_NAMES.STOP_SALES,
        getPath: (id: string) => `${URLS.FLEET}${URLS.STOP_SALES}/${id}`,
        isDisabled: disableMenuItem(MENU_NAMES.STOP_SALES),
      },
      {
        label: MENU_NAMES.TERMS_AND_CONDITIONS,
        getPath: (id: string) =>
          `${URLS.TERMS_AND_CONDITIONS}${URLS.RENTAL_INCLUDES}/${id}`,
        activePath: URLS.TERMS_AND_CONDITIONS,
        isDisabled: disableMenuItem(MENU_NAMES.TERMS_AND_CONDITIONS),
      },
    ],
    [accountStatus, sectionsStatuses]
  )

  return items
}
